import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "c-search__wrap" }
const _hoisted_2 = { class: "o-grid -search-sticky-top" }
const _hoisted_3 = { class: "o-grid-9" }
const _hoisted_4 = { class: "c-search-title" }
const _hoisted_5 = { class: "c-search-row" }
const _hoisted_6 = { class: "c-search-input-text" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "o-ico -input-left",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("title", null, "input-left"),
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#search" })
], -1 /* HOISTED */)
const _hoisted_8 = ["placeholder", "aria-label"]
const _hoisted_9 = {
  key: 0,
  class: "c-search-reset"
}
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "c-search-reset__ico" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-close",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "close"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#close" })
  ])
], -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "c-search__loading" }, null, -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "c-search-main-filters"
}
const _hoisted_15 = { class: "c-search-main-filters__item" }
const _hoisted_16 = { class: "c-search-main-filters__item" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "o-grid -y-sm" }
const _hoisted_19 = { class: "o-grid-9 c-search-results__quicklinks" }
const _hoisted_20 = { class: "o-grid -gutter -popular-search-desktop" }
const _hoisted_21 = {
  key: 0,
  class: "o-grid-3"
}
const _hoisted_22 = { class: "c-search-results__quicklinks__title" }
const _hoisted_23 = { class: "c-search-results__quicklinks__list" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "o-grid-3"
}
const _hoisted_27 = { class: "c-search-results__quicklinks__title" }
const _hoisted_28 = {
  class: "c-search-results__quicklinks__list",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_29 = ["href"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "c-search-results__quicklinks__title" }
const _hoisted_32 = { class: "c-search-results__quicklinks__list" }
const _hoisted_33 = ["href"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 2,
  class: "o-grid-3"
}
const _hoisted_36 = { class: "c-search-results__quicklinks__title" }
const _hoisted_37 = { class: "c-search-results__quicklinks__list" }
const _hoisted_38 = ["href"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 3,
  class: "o-grid-3"
}
const _hoisted_41 = { class: "c-search-results__quicklinks__title" }
const _hoisted_42 = { class: "c-search-results__quicklinks__list" }
const _hoisted_43 = ["href"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "c-accordion -popular-search-mobile" }
const _hoisted_46 = {
  class: "c-accordion__section is-open",
  "data-accordion": "wrap",
  id: "section-1"
}
const _hoisted_47 = {
  class: "c-accordion__header",
  "data-accordion": "trigger"
}
const _hoisted_48 = { class: "c-accordion__header__title o-title-5" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "c-accordion__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-arrow-down",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
  ])
], -1 /* HOISTED */)
const _hoisted_50 = {
  class: "c-accordion__content",
  role: "region",
  "data-accordion": "content"
}
const _hoisted_51 = { class: "c-accordion__inner" }
const _hoisted_52 = { class: "c-accordion__inner__container" }
const _hoisted_53 = { class: "c-search-results__quicklinks__list" }
const _hoisted_54 = ["href"]
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  class: "c-accordion__section",
  "data-accordion": "wrap",
  id: "section-2"
}
const _hoisted_57 = {
  class: "c-accordion__header",
  "data-accordion": "trigger"
}
const _hoisted_58 = { class: "c-accordion__header__title o-title-5" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "c-accordion__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-arrow-down",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
  ])
], -1 /* HOISTED */)
const _hoisted_60 = {
  class: "c-accordion__content",
  role: "region",
  "data-accordion": "content"
}
const _hoisted_61 = { class: "c-accordion__inner" }
const _hoisted_62 = { class: "c-accordion__inner__container" }
const _hoisted_63 = { class: "c-search-results__quicklinks__list" }
const _hoisted_64 = ["href"]
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  class: "c-accordion__section",
  "data-accordion": "wrap",
  id: "section-5"
}
const _hoisted_67 = {
  class: "c-accordion__header",
  "data-accordion": "trigger"
}
const _hoisted_68 = { class: "c-accordion__header__title o-title-5" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "c-accordion__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-arrow-down",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
  ])
], -1 /* HOISTED */)
const _hoisted_70 = {
  class: "c-accordion__content",
  role: "region",
  "data-accordion": "content"
}
const _hoisted_71 = { class: "c-accordion__inner" }
const _hoisted_72 = { class: "c-accordion__inner__container" }
const _hoisted_73 = { class: "c-search-results__quicklinks__list" }
const _hoisted_74 = ["href"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  class: "c-accordion__section",
  "data-accordion": "wrap",
  id: "section-3"
}
const _hoisted_77 = {
  class: "c-accordion__header",
  "data-accordion": "trigger"
}
const _hoisted_78 = { class: "c-accordion__header__title o-title-5" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", { class: "c-accordion__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-arrow-down",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
  ])
], -1 /* HOISTED */)
const _hoisted_80 = {
  class: "c-accordion__content",
  role: "region",
  "data-accordion": "content"
}
const _hoisted_81 = { class: "c-accordion__inner" }
const _hoisted_82 = { class: "c-accordion__inner__container" }
const _hoisted_83 = { class: "c-search-results__quicklinks__list" }
const _hoisted_84 = ["href"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = {
  class: "c-accordion__section",
  "data-accordion": "wrap",
  id: "section-4"
}
const _hoisted_87 = {
  class: "c-accordion__header",
  "data-accordion": "trigger"
}
const _hoisted_88 = { class: "c-accordion__header__title o-title-5" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "c-accordion__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-arrow-down",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
  ])
], -1 /* HOISTED */)
const _hoisted_90 = {
  class: "c-accordion__content",
  role: "region",
  "data-accordion": "content"
}
const _hoisted_91 = { class: "c-accordion__inner" }
const _hoisted_92 = { class: "c-accordion__inner__container" }
const _hoisted_93 = { class: "c-search-results__quicklinks__list" }
const _hoisted_94 = ["href"]
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "o-grid-12 c-search-results__overview" }
const _hoisted_97 = { class: "c-search-results__count js-search-results__count" }
const _hoisted_98 = { class: "c-search-query__wrap" }
const _hoisted_99 = { class: "c-search-query" }
const _hoisted_100 = { class: "o-grid-9 c-search-results__scroll js-search-results" }
const _hoisted_101 = { class: "c-search-results__item" }
const _hoisted_102 = { class: "c-search-result__header" }
const _hoisted_103 = {
  key: 0,
  class: "c-search-result__title"
}
const _hoisted_104 = ["href", "target", "innerHTML"]
const _hoisted_105 = ["innerHTML"]
const _hoisted_106 = { class: "c-search-result__tag" }
const _hoisted_107 = { class: "c-tag" }
const _hoisted_108 = { class: "c-search-result__desc" }
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = ["innerHTML"]
const _hoisted_111 = {
  key: 0,
  class: "c-search-result__footer"
}
const _hoisted_112 = { class: "c-search-breadcrumb" }
const _hoisted_113 = ["href"]
const _hoisted_114 = {
  key: 1,
  class: "c-search-breadcrumb__link"
}
const _hoisted_115 = {
  key: 2,
  class: "c-search-breadcrumb__separator"
}
const _hoisted_116 = ["href"]
const _hoisted_117 = {
  key: 2,
  class: "c-tag -score"
}
const _hoisted_118 = {
  key: 0,
  class: "c-search-results__load-more js-search-results__load-more"
}
const _hoisted_119 = ["disabled"]
const _hoisted_120 = {
  key: 0,
  class: "c-search__loading"
}
const _hoisted_121 = {
  key: 1,
  class: "o-ico -ico-arrow-down",
  role: "img"
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("title", null, "arrow-down", -1 /* HOISTED */)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" }, null, -1 /* HOISTED */)
const _hoisted_124 = [
  _hoisted_122,
  _hoisted_123
]
const _hoisted_125 = { class: "c-search-results__load-more__text" }
const _hoisted_126 = {
  key: 0,
  class: "o-grid-3 -col-sticky-top c-search-sub-filters"
}
const _hoisted_127 = {
  key: 0,
  class: "u-hide-under-sm"
}
const _hoisted_128 = { class: "o-title-5" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_130 = { class: "o-form c-search-sub-filters__list" }
const _hoisted_131 = { class: "o-checkbox__wrap" }
const _hoisted_132 = ["id", "value"]
const _hoisted_133 = ["for"]
const _hoisted_134 = {
  key: 1,
  class: "u-hide-over-sm"
}
const _hoisted_135 = { class: "c-accordion" }
const _hoisted_136 = {
  class: "c-accordion__section is-open",
  "data-accordion": "wrap"
}
const _hoisted_137 = {
  class: "c-accordion__header",
  "data-accordion": "trigger"
}
const _hoisted_138 = { class: "c-accordion__header__title o-title-5" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("span", { class: "c-accordion__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "o-ico -ico-arrow-down",
    role: "img"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "arrow-down"),
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/assets/img/sprite.svg?v=2#arrow-down" })
  ])
], -1 /* HOISTED */)
const _hoisted_140 = {
  class: "c-accordion__content",
  role: "region",
  "data-accordion": "content"
}
const _hoisted_141 = { class: "c-accordion__inner" }
const _hoisted_142 = { class: "c-accordion__inner__container" }
const _hoisted_143 = { class: "o-form c-search-sub-filters__list" }
const _hoisted_144 = { class: "o-checkbox__wrap" }
const _hoisted_145 = ["id", "value"]
const _hoisted_146 = ["for"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["o-container", {'-has-search-value':$data.showResults, 'loading': $data.loading}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createCommentVNode(" Title "),
          _createElementVNode("div", _hoisted_4, _toDisplayString($options.t("Que cherchez-vous?")), 1 /* TEXT */),
          _createCommentVNode(" Search bar "),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchInput) = $event)),
                type: "text",
                placeholder: $options.t('Recherche'),
                class: "o-input js-search-input",
                "aria-label": $options.t('Recherche')
              }, null, 8 /* PROPS */, _hoisted_8), [
                [_vModelText, $data.searchInput]
              ])
            ]),
            ($data.searchInput!==null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.resetSearch()), ["prevent"])),
                    class: "c-search-reset__btn js-search-reset__btn",
                    "aria-label": $options.t('Réinitialiser la recherche')
                  }, _hoisted_12, 8 /* PROPS */, _hoisted_10)
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_13
          ]),
          _createCommentVNode(" Main filters buttons "),
          ($data.showResults)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                _createElementVNode("li", _hoisted_15, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.selectSection('')), ["prevent"])),
                    class: _normalizeClass(["c-search-main-filters__link", {'is-active': this.filterSection===null}])
                  }, "Tous les résultats", 2 /* CLASS */)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sections, (section) => {
                  return (_openBlock(), _createElementBlock("li", _hoisted_16, [
                    _createElementVNode("button", {
                      onClick: _withModifiers($event => ($options.selectSection(section.name)), ["prevent"]),
                      class: _normalizeClass(["c-search-main-filters__link", {'is-active': this.filterSection==section.name}])
                    }, _toDisplayString(section.name), 11 /* TEXT, CLASS, PROPS */, _hoisted_17)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createCommentVNode(" Desktop popular search 3 cols "),
          _createElementVNode("div", _hoisted_20, [
            ($data.futur.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString($options.t("Futur(e)s étudiant(e)s")), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.futur, (lien, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (lien.lienUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: lien.lienUrl,
                              class: "c-search-results__quicklink c-search-results_quicklink_futur"
                            }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_24))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: "#",
                              onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                              class: "c-search-results__quicklink c-search-results_quicklink_futur"
                            }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_25))
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.communaute.length || $data.diplomes.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  ($data.communaute.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString($options.t("Communauté étudiante")), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_28, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.communaute, (lien, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (lien.lienUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: lien.lienUrl,
                                    class: "c-search-results__quicklink c-search-results_quicklink_etudiant"
                                  }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_29))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: "#",
                                    onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                    class: "c-search-results__quicklink c-search-results_quicklink_etudiant"
                                  }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_30))
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  ($data.diplomes.length)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("span", _hoisted_31, _toDisplayString($options.t("Diplomé(e)s")), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_32, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.diplomes, (lien, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (lien.lienUrl)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: lien.lienUrl,
                                    class: "c-search-results__quicklink c-search-results_quicklink_etudiant"
                                  }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_33))
                                : (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    href: "#",
                                    onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                    class: "c-search-results__quicklink c-search-results_quicklink_etudiant"
                                  }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_34))
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            ($data.personnel.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("span", _hoisted_36, _toDisplayString($options.t("Personnel de l'ÉTS")), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.personnel, (lien, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (lien.lienUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: lien.lienUrl,
                              class: "c-search-results__quicklink c-search-results_quicklink_personnel"
                            }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_38))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: "#",
                              onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                              class: "c-search-results__quicklink c-search-results_quicklink_personnel"
                            }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_39))
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            ($data.entreprises.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString($options.t("Entreprises")), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.entreprises, (lien, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (lien.lienUrl)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: lien.lienUrl,
                              class: "c-search-results__quicklink c-search-results_quicklink_entreprises"
                            }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_43))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: "#",
                              onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                              class: "c-search-results__quicklink c-search-results_quicklink_entreprises"
                            }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_44))
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" Mobile popular search accordions "),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("p", _hoisted_48, [
                  _createElementVNode("button", {
                    class: "c-accordion__button",
                    "aria-expanded": "false",
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = $event => ($options.toggleSection(1)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($options.t("Futur(e)s étudiant(e)s")), 1 /* TEXT */),
                    _hoisted_49
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.futur, (lien, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (lien.lienUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: lien.lienUrl,
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_54))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_55))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("p", _hoisted_58, [
                  _createElementVNode("button", {
                    class: "c-accordion__button",
                    "aria-expanded": "false",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = $event => ($options.toggleSection(2)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($options.t("Communauté étudiante")), 1 /* TEXT */),
                    _hoisted_59
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.communaute, (lien, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (lien.lienUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: lien.lienUrl,
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_64))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_65))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("div", _hoisted_67, [
                _createElementVNode("p", _hoisted_68, [
                  _createElementVNode("button", {
                    class: "c-accordion__button",
                    "aria-expanded": "false",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = $event => ($options.toggleSection(5)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($options.t("Diplomé(e)s")), 1 /* TEXT */),
                    _hoisted_69
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.diplomes, (lien, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (lien.lienUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: lien.lienUrl,
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_74))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_75))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("p", _hoisted_78, [
                  _createElementVNode("button", {
                    class: "c-accordion__button",
                    "aria-expanded": "false",
                    type: "button",
                    onClick: _cache[6] || (_cache[6] = $event => ($options.toggleSection(3)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($options.t("Personnel de l'ÉTS")), 1 /* TEXT */),
                    _hoisted_79
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.personnel, (lien, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (lien.lienUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: lien.lienUrl,
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_84))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_85))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _createElementVNode("p", _hoisted_88, [
                  _createElementVNode("button", {
                    class: "c-accordion__button",
                    "aria-expanded": "false",
                    type: "button",
                    onClick: _cache[7] || (_cache[7] = $event => ($options.toggleSection(4)))
                  }, [
                    _createElementVNode("span", null, _toDisplayString($options.t("Entreprises")), 1 /* TEXT */),
                    _hoisted_89
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", _hoisted_93, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.entreprises, (lien, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (lien.lienUrl)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: lien.lienUrl,
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_94))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: "#",
                                onClick: _withModifiers($event => ($data.searchInput=lien.motsRecherche), ["prevent"]),
                                class: "c-search-results__quicklink"
                              }, _toDisplayString(lien.label), 9 /* TEXT, PROPS */, _hoisted_95))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createCommentVNode(" Results count "),
        _createElementVNode("div", _hoisted_96, [
          _createElementVNode("span", _hoisted_97, _toDisplayString($options.results?$options.results.length:''), 1 /* TEXT */),
          _createTextVNode(" " + _toDisplayString($options.t("Résultats pour")) + " : ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_98, [
            _createTextVNode("« "),
            _createElementVNode("span", _hoisted_99, _toDisplayString($data.searchInput), 1 /* TEXT */),
            _createTextVNode(" »")
          ])
        ]),
        _createCommentVNode(" Results "),
        _createElementVNode("div", _hoisted_100, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.results, (item) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                (item.url!='#')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_103, [
                      _createElementVNode("a", {
                        href: item.url,
                        target: item.section=='Lien' && item.url.indexOf('https://www.etsmtl.ca')==-1 ? '_blank':'_self',
                        innerHTML: item.title
                      }, null, 8 /* PROPS */, _hoisted_104)
                    ]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      class: "c-search-result__title",
                      innerHTML: item.title
                    }, null, 8 /* PROPS */, _hoisted_105)),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("span", _hoisted_107, _toDisplayString(item.section), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_108, [
                (item.section=='Bottin' || item.section=='Corps enseignant')
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      innerHTML: item.subtitle
                    }, null, 8 /* PROPS */, _hoisted_109))
                  : _createCommentVNode("v-if", true),
                (item.excerpt)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      innerHTML: item.excerpt
                    }, null, 8 /* PROPS */, _hoisted_110))
                  : _createCommentVNode("v-if", true)
              ]),
              (item.breadcrumb && item.section != 'Lien' && item.section != 'Link')
                ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, [
                      (item.section!='Bottin')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.breadcrumb, (link, lkey) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (link.url!='#')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: link.url,
                                    class: "c-search-breadcrumb__link"
                                  }, _toDisplayString(link.title), 9 /* TEXT, PROPS */, _hoisted_113))
                                : (_openBlock(), _createElementBlock("span", _hoisted_114, _toDisplayString(link.title), 1 /* TEXT */)),
                              (lkey+1< item.breadcrumb.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_115, "/"))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 256 /* UNKEYED_FRAGMENT */))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: 'mailto:'+item.email,
                            class: "c-search-breadcrumb__link"
                          }, _toDisplayString(item.email), 9 /* TEXT, PROPS */, _hoisted_116)),
                      _createCommentVNode(" <span class=\"c-tag -score\" v-if=\"item.score>0\">({{ item.pageviews }} pv) {{ item.score.toFixed(4) }}</span> "),
                      (item.score>0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(item.score.toFixed(4)), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          }), 256 /* UNKEYED_FRAGMENT */)),
          ($data.searchResults && $data.searchResults.length<$data.totalResults)
            ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = _withModifiers($event => ($options.search(_ctx.from = $data.searchResults.length)), ["prevent"])),
                  class: "c-search-results__load-more__btn",
                  disabled: $data.loading
                }, [
                  ($data.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_120))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_121, _hoisted_124)),
                  _createElementVNode("span", _hoisted_125, _toDisplayString($options.t("Charger plus de résultats")), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_119)
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" Sub filters : Apparaît et se met à jour seulement si un main filter est sélectionné "),
        ($data.showResults)
          ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
              ($options.sectionCategories.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                    _createElementVNode("div", _hoisted_128, _toDisplayString($data.filterSection), 1 /* TEXT */),
                    _hoisted_129,
                    _createElementVNode("div", _hoisted_130, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sectionCategories, (cat, index) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_131, [
                          _withDirectives(_createElementVNode("input", {
                            id: 'cat-'+index,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($data.selectedCategories) = $event)),
                            value: cat,
                            class: "o-checkbox",
                            type: "checkbox"
                          }, null, 8 /* PROPS */, _hoisted_132), [
                            [_vModelCheckbox, $data.selectedCategories]
                          ]),
                          _createElementVNode("label", {
                            class: "o-checkbox-label",
                            for: 'cat-'+index
                          }, _toDisplayString(cat), 9 /* TEXT, PROPS */, _hoisted_133)
                        ]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              ($options.sectionCategories.length>0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                    _createElementVNode("div", _hoisted_135, [
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("div", _hoisted_137, [
                          _createElementVNode("h3", _hoisted_138, [
                            _createElementVNode("button", {
                              class: "c-accordion__button",
                              "aria-expanded": "false",
                              type: "button",
                              onClick: _cache[10] || (_cache[10] = $event => ($options.toggleMobileFilters($event.currentTarget)))
                            }, [
                              _createElementVNode("span", null, _toDisplayString($data.filterSection), 1 /* TEXT */),
                              _hoisted_139
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sectionCategories, (cat, index) => {
                                  return (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                    _withDirectives(_createElementVNode("input", {
                                      id: 'cat2-'+index,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (($data.selectedCategories) = $event)),
                                      value: cat,
                                      class: "o-checkbox",
                                      type: "checkbox"
                                    }, null, 8 /* PROPS */, _hoisted_145), [
                                      [_vModelCheckbox, $data.selectedCategories]
                                    ]),
                                    _createElementVNode("label", {
                                      class: "o-checkbox-label",
                                      for: 'cat2-'+index
                                    }, _toDisplayString(cat), 9 /* TEXT, PROPS */, _hoisted_146)
                                  ]))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createCommentVNode(" Quand Tous les resultats est selectionner "),
              _createCommentVNode("div v-else class=\"c-search-default-filters u-hide-under-sm\">\n\t\t\t\t\t\t<div class=\"\" v-if=\"futur.length\">\n\t\t\t\t\t\t\t<span class=\"c-search-results__quicklinks__title\">{{ t(\"Futur(e)s étudiant(e)s\") }}</span>\n\t\t\t\t\t\t\t<div class=\"c-search-results__quicklinks__list\">\n\t\t\t\t\t\t\t\t<template v-for=\"(lien, index) in futur\">\n\t\t\t\t\t\t\t\t\t<a v-if=\"lien.lienUrl\" :href=\"lien.lienUrl\" class=\"c-search-results__quicklink\">{{ lien.label }}</a>\n\t\t\t\t\t\t\t\t\t<a v-else href=\"#\" @click.prevent=\"searchInput=lien.motsRecherche\" class=\"c-search-results__quicklink\">{{ lien.label }}</a>\n\t\t\t\t\t\t\t\t</template>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"\" v-if=\"communaute.length\">\n\t\t\t\t\t\t\t<span class=\"c-search-results__quicklinks__title\">{{ t(\"Communauté étudiante\") }}</span>\n\t\t\t\t\t\t\t<div class=\"c-search-results__quicklinks__list\">\n\t\t\t\t\t\t\t\t<template v-for=\"(lien, index) in communaute\">\n\t\t\t\t\t\t\t\t\t<a v-if=\"lien.lienUrl\" :href=\"lien.lienUrl\" class=\"c-search-results__quicklink\">{{ lien.label }}</a>\n\t\t\t\t\t\t\t\t\t<a v-else href=\"#\" @click.prevent=\"searchInput=lien.motsRecherche\" class=\"c-search-results__quicklink\">{{ lien.label }}</a>\n\t\t\t\t\t\t\t\t</template>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"\" v-if=\"personnel.length\">\n\t\t\t\t\t\t\t<span class=\"c-search-results__quicklinks__title\">{{ t(\"Personnel de l'ÉTS\") }}</span>\n\t\t\t\t\t\t\t<div class=\"c-search-results__quicklinks__list\">\n\t\t\t\t\t\t\t\t<template v-for=\"(lien, index) in personnel\">\n\t\t\t\t\t\t\t\t\t<a v-if=\"lien.lienUrl\" :href=\"lien.lienUrl\" class=\"c-search-results__quicklink\">{{ lien.label }}</a>\n\t\t\t\t\t\t\t\t\t<a v-else href=\"#\" @click.prevent=\"searchInput=lien.motsRecherche\" class=\"c-search-results__quicklink\">{{ lien.label }}</a>\n\t\t\t\t\t\t\t\t</template>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div")
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 2 /* CLASS */))
}